import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useSearchParams } from 'react-router-dom'
import { CustomLink } from '../../../common/CustomLink'
import { Element } from '../../../common/html/element'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../../layout/store/slice'
import { COMPONENTS } from '../../../routers/constants'
import { AUTHORIZATION_TYPE } from '../../../utils/authorization'
import { getPanelLink } from '../constant'

export const ViewDetails = ({ id }) => {
  const [searchParams] = useSearchParams()

  const userType = useSelector(selectUserType)
  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)

  return (
    AUTHORIZATION_API.companyAnalysis.viewDetails[userType.userTypeId] ===
      AUTHORIZATION_TYPE.ALLOW && (
      <Element className="mr1" style={{ color: '#2C73E8' }}>
        <CustomLink
          to={
            getPanelLink(COMPONENTS, id) +
            `?organizationId=${searchParams.get('organizationId')}`
          }
          target="_blank"
          rel="noopener noreferrer"
        >
          <Translate value="companySummary.VIEW_DETAIL" />
        </CustomLink>
      </Element>
    )
  )
}
